export default "__VITE_ASSET__v5FbB32z__"